import { render, staticRenderFns } from "./index.vue?vue&type=template&id=051d07eb"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('051d07eb')) {
      api.createRecord('051d07eb', component.options)
    } else {
      api.reload('051d07eb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=051d07eb", function () {
      api.rerender('051d07eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/viewItem/index.vue"
export default component.exports